<template>
  <v-card class="box-container ma-0 pa-2" align="center" justify="center" style="max-height: 80vh !important; max-width: 500px !important; min-width: 300px !important">
    <div class="row-header ma-0 pa-0">
      <v-col class="ma-0 pa-0">
        <v-row class="ma-0 pa-0" align="center" justify="center">
          <span class="title">{{ title }}</span>
        </v-row>
        <v-divider></v-divider>
      </v-col>
    </div>
    <div class="row-content ma-0 pa-0">
      <v-col class="ma-0 pa-1">
        <!-- <v-row v-for="(line, idx) in lines" :key="idx" class="ma-0 pa-0" align="center" justify="start"> -->
        <span style="display: block; text-align: start; white-space: pre-wrap; word-wrap: break-all" :style="`font-size: ${fontSize}`">{{ text }}</span>
        <!-- </v-row> -->
      </v-col>
    </div>
    <div class="row-header ma-0 pa-0">
      <v-row class="ma-2 pa-0" align="center" justify="center">
        <v-col cols="3" class="ma-0 pa-0">
          <v-card
            v-if="buttonCancelText"
            align="center"
            :max-width="150"
            style="display: flex; cursor: pointer; height: 100%"
            :color="Colors.IconColor"
            class="pa-2 white--text"
            @click="resolve(null)"
          >
            <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonCancelText }}</span>
          </v-card>
        </v-col>
        <v-col cols="1" class="ma-0 pa-0"> </v-col>
        <v-col cols="3" class="ma-0 pa-0">
          <v-card
            v-if="buttonYesText"
            align="center"
            :max-width="150"
            style="display: flex; cursor: pointer; height: 100%"
            :color="Colors.IconColor"
            class="pa-2 white--text"
            @click="resolve(true)"
          >
            <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonYesText }}</span>
          </v-card>
        </v-col>
        <v-col cols="1" class="ma-0 pa-0"> </v-col>
        <v-col cols="3" class="ma-0 pa-0">
          <v-card
            v-if="buttonNoText"
            align="center"
            :max-width="150"
            style="display: flex; cursor: pointer; height: 100%"
            :color="Colors.IconColor"
            class="pa-2 white--text"
            @click="resolve(false)"
          >
            <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonNoText }}</span>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      fontSize: "1em",
      title: "",
      text: "",
      buttonYesText: "",
      buttonNoText: "",
      buttonCancelText: "",
    };
  },
  computed: {
    lines() {
      return this.text ? this.text.split("\n") : [];
    },
  },
  methods: {
    resolve(result) {
      this.dialog.result = result;
      this.dialog.close();
    },
  },
  created() {
    if (this.dialog.options) {
      this.title = this.dialog.options.title;
      this.text = this.dialog.options.text;
      if (this.dialog.options.buttonYesText != undefined) {
        this.buttonYesText = this.dialog.options.buttonYesText;
      }
      if (this.dialog.options.buttonNoText != undefined) {
        this.buttonNoText = this.dialog.options.buttonNoText;
      }
      if (this.dialog.options.buttonCancelText != undefined) {
        this.buttonCancelText = this.dialog.options.buttonCancelText;
      }
      if (this.dialog.options.fontSize != undefined) {
        this.fontSize = this.dialog.options.fontSize;
      }
    }
  },
  mounted() {},
};
</script>
